import React from 'react'
import { useQuery } from 'react-query'
import {
  FormControl,
  FormLabel,
  FormHelperText,
  Select,
  Text,
  Button
} from '@chakra-ui/react'
import Axios from '../../Axios'

export default function PartnerHierarchyFields({
  values,
  onChange,
  onSave,
  isSaving,
  canSave = true
}) {
  const {
    data: groups = [],
    isLoading,
    isError
  } = useQuery(
    ['partners', 'hierarchy-options'],
    async () => (await Axios.get('/partners/hierarchy-options')).data,
    { staleTime: 300000 }
  )
  const grade = values.hierarchicalGrade || ''
  const group =
    values.hierarchicalGroup ||
    groups.find((item) => item.grades.includes(grade))?.name ||
    ''
  const options = groups
    .filter((item) => !group || item.name === group)
    .flatMap((item) => item.grades)
  const groupOptions = [
    ...new Set([...groups.map((item) => item.name), ...(group ? [group] : [])])
  ]
  const gradeOptions = [...new Set([...options, ...(grade ? [grade] : [])])]
  return (
    <>
      <FormControl mb={3}>
        <FormLabel htmlFor="hierarchicalGroup">Grupo jerárquico</FormLabel>
        <Select
          id="hierarchicalGroup"
          name="hierarchicalGroup"
          bg="white"
          color="green.500"
          fontWeight={600}
          focusBorderColor="green.100"
          value={group}
          isDisabled={isLoading || isError}
          onChange={(event) => {
            const selected = groups.find(
              (item) => item.name === event.target.value
            )
            onChange({
              hierarchicalGroup: selected?.name || '',
              hierarchicalGrade: selected?.grades.includes(grade) ? grade : ''
            })
          }}
        >
          <option value="">Sin definir</option>
          {groupOptions.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </Select>
        <FormHelperText>
          Puedes registrar el grupo aunque todavía no conozcas el grado exacto.
        </FormHelperText>
      </FormControl>
      <FormControl mb={3}>
        <FormLabel htmlFor="hierarchicalGrade">Grado jerárquico</FormLabel>
        <Select
          id="hierarchicalGrade"
          name="hierarchicalGrade"
          bg="white"
          color="green.500"
          fontWeight={600}
          focusBorderColor="green.100"
          value={grade}
          isDisabled={isLoading || isError}
          onChange={(event) => {
            const exact = event.target.value
            onChange({
              hierarchicalGrade: exact,
              hierarchicalGroup: exact
                ? groups.find((item) => item.grades.includes(exact)).name
                : group
            })
          }}
        >
          <option value="">Sin definir</option>
          {gradeOptions.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </Select>
        <FormHelperText>
          Selecciona el grado solo cuando conozcas el valor exacto.
        </FormHelperText>
      </FormControl>
      {isError && (
        <Text color="red.600" fontSize="sm" mb={3}>
          No se pudo cargar el listado de grados. Recarga la vista para editar
          estos campos.
        </Text>
      )}
      {onSave && (
        <Button
          mb={4}
          size="sm"
          variant="outline"
          colorScheme="green"
          isLoading={isSaving}
          isDisabled={!canSave || isLoading || isError}
          onClick={onSave}
        >
          Guardar grupo y grado
        </Button>
      )}
    </>
  )
}
